import React, { useEffect, useState } from 'react';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import { browserHistory, getFullUrl } from '../core/globals';
import { getStore } from '../core/store';
import {
  setDeps,
  logout,
  loginFromLocalStorage,
} from '../core/auth/auth-actions';
import indexRoutes from '../routes';
import { initializeAPI } from '../core/services/http-request';
import { customTheme } from '../customTheme';
import { getColor } from '../core/params.js';

import { BlockComponent } from '@intervan-ar/ov-componentes';

import {
  getVersion,
  getParametro,
} from '../core/parametros/parametros-actions.js';
import { PACKAGEJSON_VERSION, ISDEVELOP } from '../core/globals.js';

const store = getStore();
setDeps(browserHistory);
initializeAPI(() => store.dispatch(logout()));

const App = () => {
  const [loading, setLoading] = useState(false);
  const theme = createTheme(customTheme);

  const verificarVersiones = (versionFrontend, versionBackend) => {
    const frontend = versionFrontend.split('.');
    const backend = versionBackend.split('.');
    //Primer dígito
    if (parseInt(frontend[0]) !== parseInt(backend[0])) {
      if (parseInt(frontend[0]) < parseInt(backend[0]))
        return {
          ok: false,
          message: 'Debe actualizar la Aplicación',
          versionFrontend,
          versionBackend,
        };
      if (parseInt(frontend[0]) > parseInt(backend[0]))
        return {
          ok: false,
          message:
            'El contenedor de servicios es de versión ' +
            versionBackend +
            ' y la versión de la aplicación es ' +
            versionFrontend +
            ', por favor contacte al administrador.',
          versionFrontend,
          versionBackend,
        };
    }
    if (parseInt(frontend[1]) !== parseInt(backend[1])) {
      if (parseInt(frontend[1]) < parseInt(backend[1]))
        return {
          ok: false,
          message: 'Debe actualizar la Aplicación',
          versionFrontend,
          versionBackend,
        };
      if (parseInt(frontend[1]) > parseInt(backend[1]))
        return {
          ok: false,
          message:
            'El contenedor de servicios es de versión ' +
            versionBackend +
            ' y la versión de la aplicación es ' +
            versionFrontend +
            ', por favor contacte al administrador.',
          versionFrontend,
          versionBackend,
        };
    }
    return {
      ok: true,
      message:
        'Version del Frontend ' +
        versionFrontend +
        ', Backend ' +
        versionBackend,
      versionFrontend,
      versionBackend,
    };
  };

  useEffect( () => {
    const init = async () => {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has('standalone'))
        localStorage.setItem('standalone', urlParams.get('standalone'));
      setLoading(true);

      var color = await getColor();
      customTheme.palette.primary.main = color;

      new Promise((resolve, reject) => {
        //Si es desarrollo saltea el checkeo de versiones
        if (ISDEVELOP) resolve();

        store
          .dispatch(getVersion({ versionApp: "version" }))
          .then((result) => {
            //comparar la version
            //Si la version no es la correct reject
            const verificacion = verificarVersiones(
              PACKAGEJSON_VERSION,
              result.version
            );
            verificacion.ok ? resolve() : reject(verificacion);
          })
          .catch((error) => {
            setLoading(false);
            console.log("ERROR", error);
          });
      })
        .then((result) => {
          store.dispatch(loginFromLocalStorage()).then(() => {
            setLoading(false);
          }, () => {
            browserHistory.replace(getFullUrl('inicio'));
            setLoading(false);
          });
        })
        .catch((error) => {
          setLoading(false);
          console.error("ERROR", error);
          alert(error.message);
        });
    };
    init();

    const welcomeDiv = document.getElementById("loading_app");
    if(welcomeDiv) welcomeDiv.remove();
  }, []);

  if (loading) return (
      <BlockComponent blocking={loading}>
      </BlockComponent>
  );
  else return (
    <Provider store={store}>
      <Router history={browserHistory}>
        <ThemeProvider theme={theme}>
          <Switch>
            {indexRoutes.map((prop, key) => {
              return (
                <Route
                  path={prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            })}
          </Switch>
        </ThemeProvider>
      </Router>
    </Provider>
  );
};
export default App;
